export default "__VITE_ASSET__DWK7AKkV__"